import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';

import { MaterialTextInput } from 'atoms/MaterialInput';

import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { CATERING, Config } from 'common/constants/SharedConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { ButtonType, ContainedButton } from '../../../../atoms/Buttons';
import { restrictUserToCharacter } from 'organisms/AccountPage/AU/accountPageUtils';
import { errorStyleForMaterialTextInput, styleForMaterialTextInput } from 'common/utilities/utils';

export const getTitlePanel = (title, children, className = '') => {
  return (
    <div className={`labelContent contact-label pl-25px  col-sm-4 col-12 ${className}`}>
      <span>{title}</span>
      {children}
    </div>
  );
};

export const getSignInPanel = (userParams, signInBtnClickHandler, btnClassName = '') => {
  return (
    !userParams?.loggedIn && (
      <ContainedButton
        variant={ButtonType.secondary}
        fullWidth
        type='button'
        className={btnClassName}
        data-testid='sign-in'
        data-id={Config?.CHECKOUT_SIGN_IN_ATTR_DATA_ID}
        onClick={signInBtnClickHandler}
      >
        {translateWithI18Next(TRANSLATE_MAPPING_KEY?.SIGN_IN)}
      </ContainedButton>
    )
  );
};

export const getSignUpPanel = params => {
  const { userParams, signUpBtnClickHandler, btnClassName = 'contactInfo-button-checkout col-12' } = params;
  return (
    !userParams?.loggedIn && (
      <ContainedButton
        variant={ButtonType.tertiary}
        fullWidth
        type='button'
        className={btnClassName}
        data-testid='sign-up'
        data-id={Config?.CHECKOUT_SIGN_UP_ATTR_DATA_ID}
        onClick={signUpBtnClickHandler}
      >
        {translateWithI18Next(TRANSLATE_MAPPING_KEY?.SIGN_UP)}
      </ContainedButton>
    )
  );
};

export const getEnterContactDetailsButtonTemplate = (params, btnClassName = '') => {
  const { updateCheckoutDetails } = params;
  return (
    <button
      type='button'
      className={`btn btn-outlined btn-margin checkout-sing-in ${btnClassName}`}
      data-testid='enter-contact-details'
      onClick={() =>
        updateCheckoutDetails({
          isCateringSomeOneElseContactDetailsEnabled: true,
          isCateringSomeOneElseContactDetailsAreValid: false,
        })
      }
    >
      {translateWithI18Next(TRANSLATE_MAPPING_KEY?.ENTER_CONTACT_DETAILS)}
    </button>
  );
};

export const getGustUserButtonTemplate = params => {
  const { checkoutDetails, continueAsaGustBtnClickHandler } = params;
  return (
    !checkoutDetails?.isEnableGustUser && (
      <div className='col-12 center-element mt-20px txt-align-center'>
        <button
          className='checkout-link-btn wd-max-content'
          type='button'
          variant={'link dark'}
          onClick={event => continueAsaGustBtnClickHandler(event)}
          data-testid='continue-as-a-gust'
        >
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.CONTINUE_AS_A_GUEST)}
        </button>
      </div>
    )
  );
};

export const getMandatoryNotePanel = (isMobile, notes) => {
  return !isMobile && <p className='mandatory-note'>{notes}</p>;
};

export const getFullNamePanel = params => {
  const {
    userFullName,
    onChangeOrOnBlurHandler,
    styleForMaterialTextInput,
    errorStyleForMaterialTextInput,
    className = '',
    disabled = null,
    classNameCont = '',
    name = '',
    maxLengthFullName,
  } = params;
  return (
    <div className={`${classNameCont}`}>
      <MaterialTextInput
        className={`formElement ${styleForMaterialTextInput(userFullName?.error)} ${className}`}
        placeholder={translateWithI18Next(TRANSLATE_MAPPING_KEY?.FULL_NAME)}
        onChange={onChangeOrOnBlurHandler}
        onBlur={onChangeOrOnBlurHandler}
        inputTestId='form-fullname'
        name={`${TRANSLATE_MAPPING_KEY?.FULL_NAME}${name !== '' ? '_' + name : ''}`}
        value={userFullName?.value}
        autocomplete='off'
        maxLength={maxLengthFullName}
        disabled={disabled}
      />
      <div id='userFullName' className={errorStyleForMaterialTextInput(userFullName?.error)}>
        {userFullName?.error && <img src={IMAGE_PATH?.Ellipse} alt='error' className={`mr-2`} />}
        <span role='alert'>{userFullName?.errorMessage}</span>
      </div>
    </div>
  );
};
export const getFirstNamePanel = params => {
  const {
    userFirstName,
    onChangeOrOnBlurHandler,
    styleForMaterialTextInput,
    errorStyleForMaterialTextInput,
    className = '',
    disabled = null,
    classNameCont = '',
    name = '',
    maxLengthFirstName,
  } = params;
  return (
    <div className={`${classNameCont}`}>
      <MaterialTextInput
        className={`formElement ${styleForMaterialTextInput(userFirstName?.error)} ${className}`}
        placeholder={translateWithI18Next(TRANSLATE_MAPPING_KEY?.FIRST_NAME_PLACE_HOLDER)}
        onChange={onChangeOrOnBlurHandler}
        onKeyPress={restrictUserToCharacter}
        onBlur={onChangeOrOnBlurHandler}
        inputTestId='form-firstname'
        name={`${TRANSLATE_MAPPING_KEY?.FIRST_NAME_LABEL}${name !== '' ? '_' + name : ''}`}
        value={userFirstName?.value}
        autocomplete='off'
        maxLength={maxLengthFirstName}
        disabled={disabled}
      />
      <div id='userFirstName' className={errorStyleForMaterialTextInput(userFirstName?.error)}>
        {userFirstName?.error && <img src={IMAGE_PATH?.Ellipse} alt='error' className={`mr-2`} />}
        <span role='alert'>{userFirstName?.errorMessage}</span>
      </div>
    </div>
  );
};

export const getLastNamePanel = params => {
  const {
    userLastName,
    onChangeOrOnBlurHandler,
    styleForMaterialTextInput,
    errorStyleForMaterialTextInput,
    className = '',
    disabled = null,
    classNameCont = '',
    name = '',
    maxLengthLastName,
  } = params;
  return (
    <div className={`${classNameCont}`}>
      <MaterialTextInput
        className={`formElement ${styleForMaterialTextInput(userLastName?.error)} ${className}`}
        placeholder={translateWithI18Next(TRANSLATE_MAPPING_KEY?.LAST_NAME_PLACE_HOLDER)}
        onChange={onChangeOrOnBlurHandler}
        onKeyPress={restrictUserToCharacter}
        onBlur={onChangeOrOnBlurHandler}
        inputTestId='form-lastname'
        name={`${TRANSLATE_MAPPING_KEY?.LAST_NAME_LABEL}${name !== '' ? '_' + name : ''}`}
        value={userLastName?.value}
        autocomplete='off'
        maxLength={maxLengthLastName}
        disabled={disabled}
      />
      <div id='userLastName' className={errorStyleForMaterialTextInput(userLastName?.error)}>
        {userLastName?.error && <img src={IMAGE_PATH?.Ellipse} alt='error' className={`mr-2`} />}
        <span role='alert'>{userLastName?.errorMessage}</span>
      </div>
    </div>
  );
};

export const getUserPhonePanel = params => {
  const {
    userPhone,
    onChangeOrOnBlurHandler,
    styleForMaterialTextInput,
    errorStyleForMaterialTextInput,
    className = '',
    disabled = null,
    classNameCont = '',
    name = '',
    maxLengthPhoneNumber,
  } = params;
  return (
    <div className={`${classNameCont}`}>
      <MaterialTextInput
        className={`formElement ${styleForMaterialTextInput(userPhone?.error)} ${className}`}
        placeholder={translateWithI18Next(TRANSLATE_MAPPING_KEY?.PHONE_NUMBER)}
        onChange={onChangeOrOnBlurHandler}
        onBlur={onChangeOrOnBlurHandler}
        inputTestId='form-phone'
        name={`${TRANSLATE_MAPPING_KEY?.PHONE}${name !== '' ? '_' + name : ''}`}
        value={userPhone?.value}
        autocomplete='off'
        maxLength={maxLengthPhoneNumber}
        disabled={disabled}
      />
      <div id='userPhone' className={errorStyleForMaterialTextInput(userPhone?.error)}>
        {userPhone?.error && <img src={IMAGE_PATH?.Ellipse} alt='error' className={`mr-2`} />}
        <span role='alert'>{userPhone?.errorMessage}</span>
      </div>
    </div>
  );
};

export const getUserEmailPanel = params => {
  const {
    userEmail,
    onChangeOrOnBlurHandler,
    styleForMaterialTextInput,
    errorStyleForMaterialTextInput,
    className = '',
    disabled = null,
    classNameCont = '',
    name = '',
    maxLengthEmail,
  } = params;
  return (
    <div className={`${classNameCont}`}>
      <MaterialTextInput
        className={`formElement ${styleForMaterialTextInput(userEmail?.error)} ${className}`}
        placeholder={translateWithI18Next(TRANSLATE_MAPPING_KEY?.EMAIL_ADDRESS)}
        onChange={onChangeOrOnBlurHandler}
        onBlur={onChangeOrOnBlurHandler}
        inputTestId='form-email'
        name={`${TRANSLATE_MAPPING_KEY?.EMAIL}${name !== '' ? '_' + name : ''}`}
        value={userEmail?.value}
        autocomplete='off'
        maxLength={maxLengthEmail}
        disabled={disabled}
      />
      <div id='userEmail' className={errorStyleForMaterialTextInput(userEmail?.error)}>
        {userEmail?.error && <img src={IMAGE_PATH?.Ellipse} alt='error' className={`mr-2`} />}
        <span role='alert'>{userEmail?.errorMessage}</span>
      </div>
    </div>
  );
};

export const contactEditBtnClickHandler = params => {
  const { updateCheckoutDetails } = params;
  updateCheckoutDetails({
    paymentEnabled: true,
    isClickAddPayment: false,
    showPreValidationPaymentContactError: true,
    tender: { name: '', payload: {} },
  });
};

export const getContactEditBtn = params => {
  return (
    <button
      type='button'
      className={`btn btn-outlined btn-margin checkout-sing-in checkout-contact-edit-btn ${params?.className}`}
      data-testid='edit'
      onClick={() => contactEditBtnClickHandler(params)}
    >
      {translateWithI18Next(TRANSLATE_MAPPING_KEY?.EDIT)}
    </button>
  );
};

export const getGustUserContactDetailsTemplate = params => {
  const { checkoutDetails, updateGustUserContactDetails, updateCheckoutDetails } = params;
  const {
    isMobile,
    userFirstName,
    userLastName,
    userPhone,
    userEmail,
    paymentEnabled,
    isClickAddPayment,
    maxLengthFirstName,
    maxLengthLastName,
    maxLengthPhoneNumber,
    maxLengthEmail,
  } = checkoutDetails;

  return (
    <div
      className={`contactInfoContent col-12 mt-0px-imp ${
        paymentEnabled && isClickAddPayment ? 'col-sm-7 d-flex' : 'col-sm-8'
      }`}
    >
      <div className={`col-12 ${paymentEnabled && isClickAddPayment ? 'p-0px-imp' : ''}`}>
        {/* userFirstName */}
        {getFirstNamePanel({
          userFirstName,
          onChangeOrOnBlurHandler: updateGustUserContactDetails,
          styleForMaterialTextInput,
          errorStyleForMaterialTextInput,
          disabled: paymentEnabled && isClickAddPayment,
          className: paymentEnabled && isClickAddPayment ? 'read-only' : '',
          maxLengthFirstName,
        })}

        {/* userLastName */}
        {getLastNamePanel({
          userLastName,
          onChangeOrOnBlurHandler: updateGustUserContactDetails,
          styleForMaterialTextInput,
          errorStyleForMaterialTextInput,
          disabled: paymentEnabled && isClickAddPayment,
          className: paymentEnabled && isClickAddPayment ? 'read-only' : '',
          maxLengthLastName,
        })}

        {/* PHONE */}
        {getUserPhonePanel({
          userPhone,
          onChangeOrOnBlurHandler: updateGustUserContactDetails,
          styleForMaterialTextInput,
          errorStyleForMaterialTextInput,
          disabled: paymentEnabled && isClickAddPayment,
          className: paymentEnabled && isClickAddPayment ? 'read-only' : '',
          maxLengthPhoneNumber,
        })}

        {/* EMAIL */}
        {getUserEmailPanel({
          userEmail,
          onChangeOrOnBlurHandler: updateGustUserContactDetails,
          styleForMaterialTextInput,
          errorStyleForMaterialTextInput,
          disabled: paymentEnabled && isClickAddPayment,
          className: paymentEnabled && isClickAddPayment ? 'read-only' : '',
          maxLengthEmail,
        })}

        {/* Info */}
        {!isClickAddPayment && (
          <div className='d-flex mt-20px mb-20px info-note'>
            <span>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.INFO_MAKE_SURE_RIGHT_NUMBER_EMAIL)}</span>
          </div>
        )}
      </div>

      {/* Edit button */}
      {!isMobile &&
        paymentEnabled &&
        isClickAddPayment &&
        getContactEditBtn({ checkoutDetails, updateCheckoutDetails })}
    </div>
  );
};

export const getEnterContactDetailsTemplate = params => {
  const { checkoutDetails, updateCateringSomeOneElseContactDetails } = params;
  const {
    maxLengthFirstName,
    maxLengthLastName,
    maxLengthPhoneNumber,
    maxLengthEmail,
    cateringSomeOneElseContactDetails,
  } = checkoutDetails;
  const { userFirstName, userLastName, userPhone, userEmail } = cateringSomeOneElseContactDetails;

  return (
    <div className={`col-12 row row-cols-12 `}>
      {/* userFirstName */}
      {getFirstNamePanel({
        name: CATERING,
        userFirstName,
        onChangeOrOnBlurHandler: updateCateringSomeOneElseContactDetails,
        styleForMaterialTextInput,
        errorStyleForMaterialTextInput,
        classNameCont: 'col-12',
        maxLengthFirstName,
      })}

      {/* userLastName */}
      {getLastNamePanel({
        name: CATERING,
        userLastName,
        onChangeOrOnBlurHandler: updateCateringSomeOneElseContactDetails,
        styleForMaterialTextInput,
        errorStyleForMaterialTextInput,
        classNameCont: 'col-12',
        maxLengthLastName,
      })}

      {/* PHONE */}
      {getUserPhonePanel({
        name: CATERING,
        userPhone,
        onChangeOrOnBlurHandler: updateCateringSomeOneElseContactDetails,
        styleForMaterialTextInput,
        errorStyleForMaterialTextInput,
        classNameCont: 'col-12',
        maxLengthPhoneNumber,
      })}

      {/* EMAIL */}
      {getUserEmailPanel({
        name: CATERING,
        userEmail,
        onChangeOrOnBlurHandler: updateCateringSomeOneElseContactDetails,
        styleForMaterialTextInput,
        errorStyleForMaterialTextInput,
        classNameCont: 'col-12',
        maxLengthEmail,
      })}

      {/* Info */}
      <div className='d-flex mt-20px mb-20px info-note'>
        <span>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.INFORM_TO_CONTACT_NOMINATED_PERSON_ORDER)}</span>
      </div>
    </div>
  );
};
